import { render, staticRenderFns } from "./tips-progress.vue?vue&type=template&id=90212e1a&scoped=true&"
import script from "./tips-progress.vue?vue&type=script&lang=js&"
export * from "./tips-progress.vue?vue&type=script&lang=js&"
import style0 from "./tips-progress.vue?vue&type=style&index=0&id=90212e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90212e1a",
  null
  
)

export default component.exports